import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { RoleModel } from '../../../libs/role';
import { GroupTypeModel } from '../../../libs/system';
import { AccountModel, ObjectRelation, ObjectRelationSetting, VatCodeModel } from '@rillion/api/models/master-data.models';

export type TemplateType = 'invoiceAccountCodingGridView';

export const MetadataActions = createActionGroup({
  source: 'Metadata',
  events: {
    'Get Roles': emptyProps(),
    'Get Roles Success': props<{ roles: RoleModel[] }>(),
    'Get Roles Failure': props<{ error: HttpErrorResponse }>(),

    'Get Group Types': props<{ template: TemplateType }>(),
    'Get Group Types Success': props<{ template: TemplateType; groupTypes: GroupTypeModel[] }>(),
    'Get Group Types Failure': props<{ error: HttpErrorResponse }>(),

    'Get Accounts': emptyProps(),
    'Get Accounts Success': props<{ accounts: AccountModel[] }>(),
    'Get Accounts Failure': props<{ error: HttpErrorResponse }>(),

    'Get Vat Codes': emptyProps(),
    'Get Vat Codes Success': props<{ vatCodes: VatCodeModel[] }>(),
    'Get Vat Codes Failure': props<{ error: HttpErrorResponse }>(),

    'Get Object Relations': emptyProps(),
    'Get Object Relations Success': props<{ objectRelations: ObjectRelation[] }>(),
    'Get Object Relations Failure': props<{ error: HttpErrorResponse }>(),

    'Get Object Relation Settings': emptyProps(),
    'Get Object Relation Settings Success': props<{ objectRelationSettings: ObjectRelationSetting[] }>(),
    'Get Object Relation Settings Failure': props<{ error: HttpErrorResponse }>(),
  },
});
